import { useGetClientConfigQuery } from "src/api";
import type { ClientConfigurationProperties } from "src/types";

export const useClientConfig = (): ClientConfigurationProperties | undefined => {
    const { data } = useGetClientConfigQuery();
    return data;
};
